<template>
  <div id="content-container">
    <InventoryIndex :category="2"></InventoryIndex>
  </div>
</template>

<script>
import InventoryIndex from './index'

export default {
  components: {
    InventoryIndex,
  },
}
</script>